import Login from './Login';
const users = {
  login: Login,
};

export default users;
